import dayjs from 'dayjs'
import {
  ButtonRemove,
  Container,
  ContainerImage,
  DownloadIcon,
  IconSvg,
  Image,
  ImagePreviewGroup,
  ImagePreviewGroupContainer,
  ImagePreviewGroupFilename,
  ImagePreviewGroupFooter,
  ImagePreviewItem,
  PdfIcon,
  TrashIcon,
} from '../styles'
import { ContainerDateTime, DateText, TimeText } from './styles'
import { IMAGE_URL } from '@/constant/IMAGE'
import { useState } from 'react'
import message from '@/libs/message'
import { useRecoilValue } from 'recoil'
import healthClaimFormAtom from '@/recoil/healthClaimForm'
import { HealthClaimModeEnum } from '@/constant/E_CLAIM'

function getLastPathSegment(url: string) {
  try {
    const { pathname } = new URL(url)
    const segments = pathname.split('/').filter(Boolean)
    return segments.pop()
  } catch (error) {
    return null
  }
}

function downloadImage(url: any, filename = 'downloaded-image.jpg') {
  fetch(url, { mode: 'cors' })
    .then((res) => res.blob())
    .then((blob) => {
      const blobUrl = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = blobUrl
      a.download = filename
      a.click()
      window.URL.revokeObjectURL(blobUrl)
    })
    .catch(() => message.error('ดาวน์โหลดไม่สำเร็จ'))
}

const PreviewImageClaim = ({
  id,
  src,
  gallery,
  dateTime,
  mimeType,
  onRemove,
  onRemovePreview,
}: {
  id: string
  src: string
  gallery?: { url: string; id: string; code: string; status: string; uploadChannel: string }[]
  dateTime?: Date
  mimeType?: string
  onRemove: (id: string) => void
  onRemovePreview: (id: string, code: string, type: string) => void
}) => {
  const healthClaim = useRecoilValue(healthClaimFormAtom)
  const isCreateOrEditMode =
    healthClaim.mode === HealthClaimModeEnum.CREATE || healthClaim.mode === HealthClaimModeEnum.EDIT
  const [isShowImagePreviewGroup, setIsShowImagePreviewGroup] = useState(false)
  const [imageUrl, setImageUrl] = useState(src)
  const [imageId, setImageId] = useState(id)
  const [isShowTrash, setIsShowTrash] = useState(true)
  const [imageCode, setImageCode] = useState<string | null>(null)
  const [imageStatus, setImageStatus] = useState<string | null>(null)
  const [revertImageId, setRevertImageId] = useState<number | null>(null)
  const date = dateTime ? dayjs(dateTime) : null
  const dateLabel = date ? date.format('DD/MM/YYYY') : 'N/A'
  const timeLabel = date ? date.format('HH:mm:ss') : ''
  const isPdf = mimeType === 'application/pdf'

  if (isPdf) {
    return (
      <Container>
        <ContainerImage>
          {isCreateOrEditMode && isShowTrash ? (
            <ButtonRemove
              shape="circle"
              icon={<IconSvg src={IMAGE_URL.closeWhiteIcon} onClick={() => onRemove(id)} />}
            />
          ) : undefined}
          <PdfIcon
            src={IMAGE_URL.minimalDocsIcon}
            onClick={() => window.open(src, '_blank', 'noopener,noreferrer')}
          />
        </ContainerImage>
        <ContainerDateTime>
          <DateText>{dateLabel}</DateText>
          <TimeText>{timeLabel}</TimeText>
        </ContainerDateTime>
      </Container>
    )
  }

  return (
    <Container>
      <ContainerImage>
        {isShowTrash ? (
          <ButtonRemove
            shape="circle"
            icon={<IconSvg src={IMAGE_URL.closeWhiteIcon} onClick={() => onRemove(id)} />}
          />
        ) : undefined}
        <Image src={src} onClick={() => setIsShowImagePreviewGroup(true)} />
        {gallery ? (
          <>
            <ImagePreviewGroupFilename isShow={isShowImagePreviewGroup}>
              {getLastPathSegment(imageUrl)}
            </ImagePreviewGroupFilename>
            <ImagePreviewGroupFooter isShow={isShowImagePreviewGroup}>
              {!isCreateOrEditMode && (
                <DownloadIcon
                  src={IMAGE_URL.downloadWhiteIcon}
                  onClick={() =>
                    downloadImage(imageUrl, getLastPathSegment(imageUrl) || 'attachment.jpg')
                  }
                  title="ดาวน์โหลด"
                />
              )}
              &nbsp;&nbsp;
              {isShowTrash ? (
                <TrashIcon
                  src={IMAGE_URL.trashWhiteIcon}
                  onClick={() => {
                    onRemovePreview(imageId, imageCode, imageStatus)
                    if (isShowImagePreviewGroup && revertImageId === 0) {
                      setIsShowImagePreviewGroup(false)
                    }
                  }}
                  title="ลบ"
                />
              ) : undefined}
            </ImagePreviewGroupFooter>
            <ImagePreviewGroup>
              <ImagePreviewGroupContainer
                preview={{
                  visible: isShowImagePreviewGroup,
                  onVisibleChange: (visible) => setIsShowImagePreviewGroup(visible),
                  countRender: (current, total) => {
                    const image = gallery[current - 1]
                    setRevertImageId(total - current)
                    if (image) {
                      setImageUrl(image.url)
                      setImageId(image.id)
                      setImageCode(image.code)
                      setImageStatus(image.status)
                      if (image.uploadChannel === 'super-app' || !isCreateOrEditMode) {
                        setIsShowTrash(false)
                      } else {
                        setIsShowTrash(true)
                      }
                    }
                    return `${current} จาก ${total}`
                  },
                  current: gallery.findIndex((item) => item.url === src),
                }}
              >
                {gallery?.map((item, index) => (
                  <div key={index}>
                    <ImagePreviewItem src={item.url} />
                  </div>
                ))}
              </ImagePreviewGroupContainer>
            </ImagePreviewGroup>
          </>
        ) : undefined}
      </ContainerImage>
      <ContainerDateTime>
        <DateText>{dateLabel}</DateText>
        <TimeText>{timeLabel}</TimeText>
      </ContainerDateTime>
    </Container>
  )
}

export default PreviewImageClaim
